import { render, staticRenderFns } from "./topic-analysis.vue?vue&type=template&id=9faa2326&scoped=true"
import script from "./topic-analysis.vue?vue&type=script&lang=js"
export * from "./topic-analysis.vue?vue&type=script&lang=js"
import style0 from "./topic-analysis.vue?vue&type=style&index=0&id=9faa2326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faa2326",
  null
  
)

export default component.exports